import type {
    PortalHostedCardEntryAdapter,
    PortalHostedCardEntryProps,
} from '@/lib/ipg/card-entry';

type HostedInvoiceCardEntryProps = PortalHostedCardEntryProps & {
    adapter: PortalHostedCardEntryAdapter;
};

export function HostedInvoiceCardEntry({ adapter, ...props }: HostedInvoiceCardEntryProps) {
    if (adapter.component === null) {
        return (
            <div
                role="alert"
                className="rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-700"
            >
                Hosted card entry is unavailable for this payment provider.
            </div>
        );
    }
    const ProviderCardEntry = adapter.component;
    return <ProviderCardEntry {...props} />;
}
